import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

export default class ViewAccount extends Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    accountCCEmails: PropTypes.object.isRequired,
  };

  renderFieldAndLabel = (label, value) => (
    <div className={`${value} row`}>
      <div className="order-label col-md-4">
        <h6>{label}:</h6>
      </div>
      <div className="order-value col-md-8">{value}</div>
    </div>
  );

  renderAccountLogo = () => {
    const { account: { companyName, logoUrl } } = this.props;
    return (
      <div className="row">
        <div className="col-xs-12">
          <div className="card card-block">
            <img src={`${logoUrl}`} alt={companyName} height="100" />
          </div>
        </div>
      </div>
    );
  };

  renderAccountFieldsOne = () => {
    const { account } = this.props;

    return (
      <div className="col-sm-6">
        <div>
          <div className="card card-block">
            {this.renderFieldAndLabel('Address 1', account.address1)}
            {this.renderFieldAndLabel('Address 2', account.address2)}
            {this.renderFieldAndLabel('City', account.city)}
            {this.renderFieldAndLabel('State', account.stateProvince)}
            {this.renderFieldAndLabel('Country', account.country)}
            {this.renderFieldAndLabel('Postal Code', account.postcode)}
            {this.renderFieldAndLabel('Phone Number', account.phone)}
            {this.renderFieldAndLabel('Website', account.url)}
          </div>
        </div>
      </div>
    );
  };

  renderAccountFieldsTwo = () => {
    const { account } = this.props;
    const createdOn = new Date(account.createdOn).toDateString();
    const updatedOn = new Date(account.updatedOn).toDateString();
    const contractAutorenew = account.get('contractAutorenew');
    const creditsEnabled = account.get('creditsEnabled');

    return (
      <div className="col-sm-6">
        <div>
          <div className="card card-block">
            {this.renderFieldAndLabel('Account Type', account.accountTypeId)}
            {this.renderFieldAndLabel('Portal Host', account.portalHost)}
            {this.renderFieldAndLabel('Created On', createdOn)}
            {this.renderFieldAndLabel('Updated On', updatedOn)}
            {this.renderFieldAndLabel('Credits Enabled', creditsEnabled.toString())}
            {this.renderFieldAndLabel(
              'Contract Auto Renew',
              contractAutorenew !== null ? contractAutorenew.toString() : null
            )}
          </div>
        </div>
      </div>
    );
  };

  renderAccountEmails = () => {
    const { accountCCEmails } = this.props;

    return (
      <div className="col-sm-6">
        <div>
          <div className="card card-block">
            <h4>Account CC Emails</h4>
            {accountCCEmails.map(accountEmail => <p key={accountEmail.id}>{accountEmail.email}</p>)}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { account, accountCCEmails } = this.props;
    return (
      <div>
        <div className="row row-top">
          <div className="col-xs-12">
            <span className="pull-right">
              <Link to={`/superadmin/accounts/edit/${account.id}`} className="btn btn-primary">
                Edit Account
              </Link>
            </span>
            <h1>{account.companyName}</h1>
          </div>
        </div>
        {account.logoUrl ? this.renderAccountLogo() : null}
        <div className="row">
          {this.renderAccountFieldsOne()}
          {this.renderAccountFieldsTwo()}
        </div>
        <div className="row">{accountCCEmails.size > 0 ? this.renderAccountEmails() : null}</div>
      </div>
    );
  }
}
